import { render } from "./pb-faq.vue?vue&type=template&id=fe90b3fe"
import script from "./pb-faq.vue?vue&type=script&lang=js"
export * from "./pb-faq.vue?vue&type=script&lang=js"

import "./pb-faq.vue?vue&type=style&index=0&id=fe90b3fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__